import { OrgAddress } from './org-address.model';
import { OrganizationSummary } from './organization-summary.model';
import { ProductsSummary } from './products.model';

export interface OrgListResponse {
	organizations: OrgGroup[];
	orgs: OrgListSummary[];
}

export interface OrgRegistration {
	address: OrgAddress;
	cnpj: string;
	contact_email: string | null;
	contact_name: string | null;
	contact_phone: string | null;
	is_matriz: boolean;
	matriz_id: string | null;
	municipal_registration: string;
	name: string;
	name_economic_group: string;
	name_secondary: string;
	products: ProductsSummary[];
	state_registration: string;
}

export interface OrgHubItem {
	color: string;
	description: string;
	icon: string;
	path: string;
	title: string;
}

export interface ViaCepResponse {
	bairro?: string;
	cep?: string;
	complemento?: string;
	ddd?: string;
	erro?: boolean;
	gia?: string;
	ibge?: string;
	localidade?: string;
	logradouro?: string;
	siafi?: string;
	uf?: string;
}

export interface MessageResponse {
	message: string;
	type: string;
}

export interface URLResponse {
	url: string;
}

export interface IdAndMessageResponse2 {
	id: string;
	message: string;
	type: string;
}

export interface AddressResult {
	city?: string;
	error: boolean;
	neighborhood?: string;
	state?: string;
	street?: string;
}

export interface NewOrganizationRequest {
	address: OrgAddress;
	cnpj: string;
	contact_email: string | null;
	contact_name: string | null;
	contact_phone: string | null;
	is_matriz: boolean;
	matriz_id: string | null;
	municipal_registration: string;
	name: string;
	name_economic_group: string;
	name_secondary: string;
	products: ProductsSummary[];
	state_registration: string;
}

export interface OrgGroup {
	beneficiary_count: number;
	clients: OrganizationSummary[];
	name: string;
	user_count: number;
}

export interface OrgListSummary {
	id: string;
	name: string;
	secondary: { id: string; name: string }[];
}

export interface GroupsListResponse {
	groups: GroupsListSummary[];
}

export interface GroupsListSummary {
	id: string;
	name: string;
}

export interface HeadquarterSummary {
	id: string;
	cnpj: string;
	name: string;
}

export interface PartnerRegistration {
	id: string;
	city?: string;
	cnpj: string;
	dental_plan: boolean;
	health_plan: boolean;
	municipal_registration?: string;
	name: string;
	name_secondary: string;
	state?: string;
	state_registration?: string;
}

export interface PartnerRequest {
	city?: string;
	cnpj: string;
	dental_plan: boolean;
	health_plan: boolean;
	municipal_registration?: string;
	name: string;
	name_secondary: string;
	state?: string;
	state_registration?: string;
}

export interface OrgUsersResponse {
	users: OrgUser[];
}

export interface OrgUser {
	id: string;
	active: boolean;
	created_at: string;
	name: string;
	org_name: string;
	phone: string;
}

export interface UserRequest {
	active: boolean;
	cpf: string;
	email: string;
	groups_id: string[];
	name: string;
	orgs_id: string[];
	password: string;
	phone: string;
	status: number;
}

export interface UserRegistration {
	active: boolean;
	cpf: string;
	email: string;
	group: { id: string; name: string }[];
	name: string;
	organization: { id: string; name: string }[];
	password: string;
	phone: string;
	sanus_partner: boolean;
}

export interface UserEditRequest {
	active: boolean;
	cpf: string;
	email: string;
	groups_disconnect: string[];
	groups_id: string[];
	name: string;
	orgs_disconnect: string[];
	orgs_id: string[];
	phone: string;
	status: number;
}

export interface CNPJAvailability {
	result: boolean;
}

export interface AvailabilityResponse {
	resp: boolean;
}

export interface CpfCheckResponse {
	exist: boolean;
}

export type DashReportType = 'HEALTH' | 'REASON' | 'SPECIALITY';

export interface DashChartsUrlsResponse {
	reports: DashChartInfo[];
}

export interface DashChartInfo {
	id: string;
	link: string;
	name: DashReportType;
	organization_id: string;
	organization_name: string;
}

export interface DashChartResponse {
	report: DashReportChart[];
}

export interface DashReportChart {
	data: DashReportData[];
	totalCount: number;
	type: DashReportType;
}

export interface DashBeneInfo {
	beneficiaryActivated: number;
	beneficiaryInactivated: number;
	beneficiaryIncluded: number;
}

export interface DashReportData {
	category: string;
	value: number;
	width?: string;
}

export const GROUP_LABELS = [
	{ label: 'Super', name: 'super' },
	{ label: 'Master', name: 'master' },
	{ label: 'Admin', name: 'admin' },
	{ label: 'Operador', name: 'operador' },
	{ label: 'Beneficiário', name: 'beneficiario' },
];
